import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

// axios.defaults.timeout = 120000
axios.defaults.timeout = 480000 // 8 minutes

// Interceptor for each request
axios.interceptors.request.use(config => {
  const deviceId = Vue.prototype.$custom.getDeviceId()
  if (deviceId) {
    config.headers['X-Device-Id'] = deviceId
  }
  return config
})


Vue.use(VueAxios, axios)

export default {
  root: axios.defaults.baseURL,
}
